export default "__VITE_ASSET__BgK8kOMW__"